import React from "react";
import {
  Accordion,
  BannerList,
  BannerVideo,
  ButtonAdmission,
  Carousels,
  CardsCarousel,
  CardsList,
  DiagonalBanner,
  DiariesSchedule,
  DiariesScheduleAll,
  Formulario,
  FrameSection,
  Hero,
  IconsCarousel,
  IconsInfo,
  InfoCards,
  Location,
  LogosSection,
  Maps,
  NoticesAndNovelties,
  NoveltiesCarousel,
  PdfPreview,
  PosgradoCareerFeed,
  PosgradoCareerFeedAll,
  Professionals,
  Quote,
  SocialMedias,
  TabsContent,
  TextColumn,
  TextContent,
  TextImage,
  Transition,
  Video,
  VideoBackground,
  SingleImage,
  BannerButtons,
} from "../components";
import {
  ACCORDION_VERTICAL,
  ADMISION_BUTTON,
  BANNER,
  BANNER_BUTTONS,
  BANNER_CAROUSEL,
  BANNER_LIST,
  BANNER_VIDEO,
  BUILDING_LOCATION,
  BUTTON,
  CARDS_CAROUSEL,
  CARDS_LIST,
  DIAGONAL_BANNER,
  DIARIES_LIST,
  DIARIES_LIST_ALL,
  FORM_CONNECT,
  FRAME_SECTION,
  HERO,
  ICONS_CAROUSEL,
  ICONS_TEXT,
  INFO_CARDS,
  LOGOS_SECTION,
  MAPS,
  NOVELTIES_LIST,
  NOVELTIES_CAROUSEL,
  TABS,
  P_CAREER_FEED,
  PDF,
  PROFESSIONALS,
  QUOTE,
  SINGLE_IMAGE,
  SOCIAL_MEDIAS,
  TEXT_COLUMN,
  TEXT_CONTENT,
  TEXT_CONTENT_PAGES,
  TEXT_IMAGE,
  TRANSITION,
  VIDEO,
  VIDEO_BACKGROUND,
  // AUDIO_LIST,
  // CALENDAR,
  // CONTACT_FORM,
  // EVENTUALITIES_LIST,
  // FORM_CONNECT,
  // GENERAL_FORM,
} from '../utils/variables/dynamicZoneComponents'
import Button from "../shared/Button/Button";

const DynamicZone = ({ components, isHome = false }) => {
  return components.map((component) => {
    // switch (component.strapi_component) {
    switch (component.__component) {
      case ACCORDION_VERTICAL:
        return (
          component.accordion && (
            <Accordion 
              key={`accordion-${component.id}`}
              data={component.accordion} 
              title={component.title} />
          )
        )
      case ADMISION_BUTTON:
        return (
          component.visible && (
            <ButtonAdmission
              key={`admisionButtonId-${component.id}`}
              career={component.career}
            />
          )
        )
      case BANNER:
        return (
          component.slide &&
          component.visible && (
            <Carousels
              key={`carousel-${component.id}`}
              carousel={component}
              isHome={isHome}
            />
          )
        )
      case BANNER_BUTTONS:
        return (
          component.bannerButtons && (
            <BannerButtons
              key={`BannerButtons-${component.id}`}
              backgroundImage={component.backgroundimage}
              imageFilter={component.imageFilter}
              imageMobile={component.imageMobile}
              content={component.content}
              bannerButtons={component.bannerButtons}
            />
          )
      )
      case BANNER_CAROUSEL:
        return (
          component.slide &&
          component.visible && (
            <div
              key={`bannerCarouselId-${component.id}`}
              className="w-100 my-5 p-0 d-flex flew-column container"
            >
              <Carousels
                carousel={component}
                bannerCarousel={true} 
              />
            </div>
          )
        )
      case BANNER_LIST:
        return (
          component.BannerListContent && (
            <BannerList
              key={`bannerList-${component.id}`}
              data={component.BannerListContent} 
            />
          )
        )
      case BANNER_VIDEO:
        return (
          component.visible && (
            <BannerVideo
              key={`bannerVideo-${component.id}`}
              bannerVideo={component} 
            />
          )
        )
      case BUILDING_LOCATION:
        return (
          component.buildingsLocationList &&
          component.buildingsLocationList.visible && (
            <Location 
              key={`buildingLocation-${component.id}`}  
              data={component.buildingsLocationList} 
            />
          )
        )
      case BUTTON:
        return (
          component.button &&
          component.customButton && (
            <Button
              key={`buttonId-${component.id}`}
              icon={component?.icon}
              button={component.button}
              customButton={component.customButton}
              matchPages={[]}
            ></Button>
          )
        )
      case CARDS_CAROUSEL:
        return (
          component.carouselCard && (
            <CardsCarousel
              key={`cardCarousel-${component.id}`}
              title={component.title}
              cards={component.carouselCard}
            />
          )
        )
      case CARDS_LIST:
        return (
          component.cards &&
          component.visible && (
            <CardsList
              key={`cardsListId-${component.id}`}
              data={component}
              isLivingVocationData={true}
            />
          )
        )
      case DIAGONAL_BANNER:
        return (
          component.diagonalContent && (
            <DiagonalBanner 
              key={`diagonalBanner-${component.id}`}  
              data={component.diagonalContent}
            />
          )
        )
      case DIARIES_LIST:
        return (
          component.schedule &&
          component.visible && (
            <DiariesSchedule
              key={`diariesListId-${component.id}`}
              diaries={ component.schedule }
              isHomeUcc={true}
              title={component.title}
            />
          )
        )
      case DIARIES_LIST_ALL:
        return (
          component && (
            <DiariesScheduleAll
              key={`diariesListId-${component.id}`}
              title={component.title}
            />
          )
        )
      case FORM_CONNECT:
        return (
          component.form &&
          component.form.id !== null && (
            <Formulario
              key={`formId-${component.form.id}`}
              idForm={component.form.id}
              title={component.title}
              receiverGeneral={component.interest_receiver?.receiver}
              typeGeneral={component.interest_type}
            />
          )
        )
      case FRAME_SECTION:
        return (
          component.frameSection &&
          component.frameSection.visible && (
            <FrameSection
              key={`frameSectionId-${component.id}`} 
              frameSection={component.frameSection} 
            />
          )
        )
      case HERO:
        return (
          component.heroContent && (
            <Hero 
              key={`hero-${component.id}`} 
              data={component.heroContent} 
            />
          )
        )
      case ICONS_CAROUSEL:
        return (
          component.icons && (
            <IconsCarousel
              key={`iconsCarousel-${component.id}`} 
              title={component.title}
              icons={component.icons}
            />
          )
        )
      case ICONS_TEXT:
        return component.iconTexts && 
          <IconsInfo 
            key={`iconTexts-${component.iconTexts.id}`}
            data={component.iconTexts} 
          />
      case INFO_CARDS:
        return (
          component.cards &&
          component.visible && (
            <InfoCards 
              key={`infoCardId-${component.id}`} 
              data={component}
            />
          )
        )
      case LOGOS_SECTION:
        return (
          component.logoSection && (
            <LogosSection 
              key={`logosSectionId-${component.id}`}
              data={component.logoSection}
            />
          )
        )
      case MAPS:
        return (
          component.MapContent &&
          component.visible && (
            <Maps
              key={`mapId-${component.id}`} 
              title={component.title ?? "Map Component"} 
              maps={component.MapContent} 
            />
          )
        )
      case NOVELTIES_LIST:
        return (
          component.novelties &&
          component.visible && (
            <NoticesAndNovelties
              key={`noveltiesListId-${component.id}`}
              novelties={component.novelties}
              title={component.title}
              latest={component.latest}
            />
          )
        )
      case NOVELTIES_CAROUSEL:
        return (
          component.novelties &&
          component.visible && (
            <NoveltiesCarousel
              key={`noveltiesCarouselId-${component.id}`}
              novelties={component.novelties}
              title={component.title}
            />
          )
        )
      case P_CAREER_FEED:
        return (
          component.feedPosgradoContent && (
            <div className='mb-5 container' key={`feedPosgradoId-${component.id}`} >
              {component.feedPosgradoContent.type === "careerList" 
                ? 
                  <PosgradoCareerFeed
                    title={component.feedPosgradoContent.title}
                    careerPlacesFilter={component.feedPosgradoContent.ucc_career_place} 
                    careerModalityFilter={component.feedPosgradoContent.modality}
                    careerMicrosite={component.feedPosgradoContent.p_ucc_microsite}
                  /> 
                :
                  <PosgradoCareerFeedAll
                    title={component.feedPosgradoContent.title}
                    careerPlacesFilter={component.feedPosgradoContent.ucc_career_place} 
                    careerModalityFilter={component.feedPosgradoContent.modality}
                    careerMicrosite={component.feedPosgradoContent.p_ucc_microsite}
                  />
              }
            </div>
          )
        )
      case PDF:
        return (
          component.pdf &&
          component.pdf.visible && (
            <PdfPreview
              key={`pdfId-${component.id}`}
              pdfPreview={component.pdf}
            />
          )
        )
      case PROFESSIONALS:
        return (
          component.profesionals &&
          component.visible && (
            <Professionals
              key={`professionalId-${component.id}`}
              title={component.title}
              professionals={component.profesionals}
            />
          )
        )
      case QUOTE:
        return (
          component.quoteContent &&
          component.quoteContent.professional?.name != null && (
            <Quote 
              key={`quote-${component.id}`}
              data={component.quoteContent} 
            />
          )
        )
      case SINGLE_IMAGE:
        return (
          component.singleImage?.image?.url &&
          component.singleImage.visible && (
            <SingleImage
              key={`singleImageId-${component.id}`}
              singleImage={component.singleImage}
            />
          )
        )
      case SOCIAL_MEDIAS:
        return (
          component.socialNetworks &&
          component.socialNetworks.visible && (
            <SocialMedias
              key={`socialMediaId-${component.id}`}
              socialMedias={component.socialNetworks}
            />
          )
        )
      case TABS:
        return (
          component.tabs &&
          component.visible && (
            <TabsContent
              key={`tabId-${component.id}`}
              data={component.tabs}
              title={component.title}
            />
          )
        )
      case TEXT_COLUMN:
        return (
          component.leftText &&
          component.rightText && (
            <TextColumn
              key={`textColumn-${component.id}`}
              title={component.title}
              leftText={component.leftText}
              rightText={component.rightText}
            />
          )
        )
      case TEXT_CONTENT:
      case TEXT_CONTENT_PAGES:
        return (
          component.textContent &&
          component.textContent.visible && (
            <TextContent
              key={`textComponentId-${component.textContent.id}`}
              component={component}
            />
          )
        )
      case TEXT_IMAGE:
        return (
          component.brick &&
          component.brick.visible && (
            <TextImage
              key={`brickId-${component.id}`}
              data={component.brick}
            />
          )
        )
      case TRANSITION:
        return (
          component.transitionContent && (
            <Transition
              key={`transitionId-${component.id}`}
              text={component.transitionContent.text}
              image={component.transitionContent.image}
              imagePosition={component.transitionContent.imagePosition}
              color={component.transitionContent.color}
            />
          )
        )
      case VIDEO:
        return (
          component.video &&
          component.video.visible && (
            <Video
              key={`videoId-${component.id}`}
              videoComponent={component.video}
            />
          )
        )
      case VIDEO_BACKGROUND:
        return (
          component.videoBack && (
            <VideoBackground
              key={`videoBackground-${component.id}`}
              video={component.videoBack.video}
              description={component.videoBack.description}
              title={component.videoBack.title}
              button={component.videoBack.buttonVideo}
              strapi={component.__component}
              id={component.id}
              backgroundImage={component.videoBack.backgroundImage}
              videoUrl={component.videoBack.videoUrl}
            />
          )
        )
      
      // case CALENDAR:
      //   return (
      //     component.calendar &&
      //     component.calendar.code.visible && (
      //       <Calendar
      //         calendarPreview={component.calendar}
      //         key={`calendarId-${component.id}`}
      //       />
      //     )
      //   )
      // case EVENTUALITIES_LIST:
      //   return (
      //     component.eventualitiesList &&
      //     component.visible && (
      //       <Eventualities
      //         eventualitiesName={component.title}
      //         eventualities={component.eventualitiesList}
      //         eventualityVisibleLength={visibleLengthFilter(
      //           component,
      //           component.eventualitiesList
      //         )}
      //         key={`entualityId-${component.id}`}
      //       />
      //     )
      //   )
      // case AUDIO_LIST:
      //   return (
      //     component.audioList &&
      //     component.visible && (
      //       <Audio
      //         audio={component.audioList}
      //         audiosVisibleLength={visibleLengthFilter(
      //           component,
      //           component.audioList
      //         )}
      //         key={`audioId-${component.id}`}
      //       />
      //     )
      //   )
      default:
        return null
    }
  })
};

export default DynamicZone;
